import { __extends } from "tslib";
import React from 'react';
import { Field } from 'formik';
import PollAnswerImage from './PollAnswerImage';
import PollAnswer from './PollAnswer';
import Trashcan from '../../Icons/Trashcan';
import s from './PollEditPopup.scss';
var PollAnswerField = /** @class */ (function (_super) {
    __extends(PollAnswerField, _super);
    function PollAnswerField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderRemoveButton = function () {
            var onRemoveClick = _this.props.onRemoveClick;
            return (React.createElement("span", { className: s['remove-answer-button'], onClick: onRemoveClick },
                React.createElement(Trashcan, null)));
        };
        return _this;
    }
    PollAnswerField.prototype.render = function () {
        var _a = this.props, index = _a.index, answer = _a.answer, canRemove = _a.canRemove, onChange = _a.onChange, onImageClick = _a.onImageClick;
        return (React.createElement("div", { className: s['answer-item'] },
            React.createElement(Field, { name: "answers." + answer.id, render: function () {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(PollAnswerImage, { deviation: answer.deviation, onClick: onImageClick }),
                        React.createElement(PollAnswer, { className: s['answer-input'], answer: answer, index: index, handleEditorChange: onChange })));
                } }),
            canRemove && this.renderRemoveButton()));
    };
    return PollAnswerField;
}(React.Component));
export default PollAnswerField;
//# sourceMappingURL=PollAnswerField.js.map